var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4346 5.83087L12.8097 0.206016C12.6785 0.0746719 12.4993 0 12.3125 0H2.46875C1.30564 0 0.359375 0.946266 0.359375 2.10938V21.8906C0.359375 23.0537 1.30564 24 2.46875 24H16.5312C17.6944 24 18.6406 23.0537 18.6406 21.8906V6.32812C18.6406 6.13641 18.5601 5.95636 18.4346 5.83087ZM13.0156 2.40061L16.24 5.625H13.7188C13.331 5.625 13.0156 5.30958 13.0156 4.92188V2.40061ZM16.5312 22.5938H2.46875C2.08105 22.5938 1.76562 22.2783 1.76562 21.8906V2.10938C1.76562 1.72167 2.08105 1.40625 2.46875 1.40625H11.6094V4.92188C11.6094 6.08498 12.5556 7.03125 13.7188 7.03125H17.2344V21.8906C17.2344 22.2783 16.919 22.5938 16.5312 22.5938Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 9.9375H5.28125C4.89294 9.9375 4.57812 10.2523 4.57812 10.6406C4.57812 11.0289 4.89294 11.3438 5.28125 11.3438H13.7188C14.1071 11.3438 14.4219 11.0289 14.4219 10.6406C14.4219 10.2523 14.1071 9.9375 13.7188 9.9375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 12.75H5.28125C4.89294 12.75 4.57812 13.0648 4.57812 13.4531C4.57812 13.8414 4.89294 14.1562 5.28125 14.1562H13.7188C14.1071 14.1562 14.4219 13.8414 14.4219 13.4531C14.4219 13.0648 14.1071 12.75 13.7188 12.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 15.5625H5.28125C4.89294 15.5625 4.57812 15.8773 4.57812 16.2656C4.57812 16.6539 4.89294 16.9688 5.28125 16.9688H13.7188C14.1071 16.9688 14.4219 16.6539 14.4219 16.2656C14.4219 15.8773 14.1071 15.5625 13.7188 15.5625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 18.375H5.28125C4.89294 18.375 4.57812 18.6898 4.57812 19.0781C4.57812 19.4664 4.89294 19.7812 5.28125 19.7812H10.9062C11.2946 19.7812 11.6094 19.4664 11.6094 19.0781C11.6094 18.6898 11.2946 18.375 10.9062 18.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.7d2d17f4ca81f28934dc3fc1f9c73fd7.svg";
export { ForwardRef as ReactComponent };